import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("adminToken");

  if (!token) {
    // If there's no token, redirect to login page
    return <Navigate to="/login" />;
  }

  // If the token exists, allow access to the page
  return children;
};

export default ProtectedRoute;
